'use client';
import Button from '@/components/button/button';
import React, { useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { VscClose } from 'react-icons/vsc';
interface ModalComponentProps {
  buttonText: string;
  buttonColor: string;
  buttonhref: string;
}
export default function CultureCodeModal({
  buttonhref,
  buttonText,
  buttonColor,
}: ModalComponentProps) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <Row xs="auto" className="justify-content-center">
        <Col className="corevalue-text">
          <Button
            size="lg"
            variant="primary"
            onClick={() => setModalShow(true)}
            style={{
              backgroundColor: buttonColor,
            }}
          >
            {buttonText}
          </Button>
        </Col>
      </Row>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        aria-modal="true"
        role="dialog"
        centered
        className="video-modal"
      >
        <Modal.Body className="video-modal-body">
          <Button
            variant="text"
            onClick={() => setModalShow(false)}
            className="close-btn"
          >
            <VscClose />
          </Button>
          <div className="iframe-container">
            <iframe
              src={buttonhref}
              width="100%"
              height="500px"
              frameBorder="0"
              allowFullScreen
              title="Slideshow"
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
